import * as echarts from 'echarts'
import store from '../../../store'
export default{
    // 国内专利分析
    // 1.国内专利趋势
    domesticsbtrend:function(){
        let myChart = echarts.init(document.querySelector(".domesticsbtrend"));
        let options={
            tooltip: {
                trigger: 'axis',
                axisPointer: {
                    type: 'cross',
                    label: {
                        backgroundColor: '#6a7985'
                    }
                },
            },
            toolbox: {
                feature: {
                    saveAsImage: {
                        title:false
                    }
                },
                bottom: 10
            },
            legend:{
                icon:"rect",
                right:30
            },
            grid:{
                top:"12%",
                bottom:0,
                left:"4%",
                right:"5%",
                containLabel: true
            },
            xAxis: {
                type: 'category',
                data: store.state.trendTimesb,
                axisLabel:{
                    color:"#000",
                    interval: 0
                }
            },
            yAxis: {
                type: 'value'
            },
            series: [{
                name:"申请量",
                data: store.state.trendApListsbY1,
                type: 'bar',
                itemStyle:{
                    color:"#73A0FA"
                },
                label:{
                    show:true,
                    position:"top"
                },
                barMaxWidth:55
            },
            {
                name:"注册量",
                data: store.state.trendApListsbY2,
                type: 'bar',
                itemStyle:{
                    color:"#FFAB67"
                },
                label:{
                    show:true,
                    position:"top"
                },
                barMaxWidth:55
            }]
        }
        myChart.setOption(options);
        window.addEventListener('resize', () => {
            myChart.resize()
        })
    },
    // 2.国际分类Top10
    intertype101: function () {
        let myChart = echarts.init(document.querySelector(".intertype101"));
        let options = {
            tooltip: {
                trigger: 'axis',
                axisPointer: {
                    type: 'shadow'
                }
            },
            toolbox: {
                feature: {
                    saveAsImage: {
                        title:false
                    }
                },
                bottom: 10
            },
            grid: {
                left: '2%',
                right: '4%',
                bottom: '3%',
                top: "15%",
                containLabel: true
            },
            xAxis: {
                type: 'value',
                boundaryGap: [0, 0.01],
                axisLine: {
                    show: true,
                    lineStyle: {
                        color: "#ddd",
                        width: 2
                    }
                },
                axisLabel: {
                    show: false
                },

            },
            yAxis: {
                type: 'category',
                data: store.state.icTop10MapsbY,
                triggerEvent: true,
                axisLine: {
                    lineStyle: {
                        color: "#ddd",
                        width: 2
                    }
                },
                axisLabel: {
                    color: "#000",
                    formatter: function (params) {
                        var val = ""
                        if (params.length > 10) {
                            val = params.substr(0, 10) + "..."
                            return val
                        } else {
                            return params
                        }
                    }
                },
                inverse: true
            },
            series: [
                {
                    name: '申请量',
                    type: 'bar',
                    data: store.state.icTop10MapsbX,
                    label: {
                        show: true,
                        color: "#000",
                        position: 'right'
                    },
                    itemStyle: {
                        normal: {
                            color: new echarts.graphic.LinearGradient(0, 0, 1, 0, [{
                                offset: 0,
                                color: '#28BEAE'
                            }, {
                                offset: 1,
                                color: '#3EDDCC'

                            }])
                        }
                    },
                    barMaxWidth:55
                },

            ]
        };
        myChart.setOption(options);
        window.addEventListener('resize', () => {
            myChart.resize()
        })
    },
    intertype102: function () {
        let myChart = echarts.init(document.querySelector(".intertype102"));
        let options = {
            tooltip: {
                trigger: 'axis',
                axisPointer: {
                    type: 'shadow'
                }
            },
            toolbox: {
                feature: {
                    saveAsImage: {
                        title:false
                    }
                },
                bottom: 10
            },
            grid: {
                left: '2%',
                right: '4%',
                bottom: '3%',
                top: "15%",
                containLabel: true
            },
            xAxis: {
                type: 'value',
                boundaryGap: [0, 0.01],
                axisLine: {
                    show: true,
                    lineStyle: {
                        color: "#ddd",
                        width: 2
                    }
                },
                axisLabel: {
                    show: false
                },

            },
            yAxis: {
                type: 'category',
                data: store.state.icRegTop10MapsbY,
                triggerEvent: true,
                axisLine: {
                    lineStyle: {
                        color: "#ddd",
                        width: 2
                    }
                },
                axisLabel: {
                    color: "#000",
                    formatter: function (params) {
                        var val = ""
                        if (params.length > 10) {
                            val = params.substr(0, 10) + "..."
                            return val
                        } else {
                            return params
                        }
                    }
                },
                inverse: true
            },
            series: [
                {
                    name: '注册量',
                    type: 'bar',
                    data: store.state.icRegTop10MapsbX,
                    label: {
                        show: true,
                        color: "#000",
                        position: 'right'
                    },
                    itemStyle: {
                        normal: {
                            color: new echarts.graphic.LinearGradient(0, 0, 1, 0, [{
                                offset: 0,
                                color: '#28BEAE'
                            }, {
                                offset: 1,
                                color: '#3EDDCC'

                            }])
                        }
                    },
                    barMaxWidth:55
                },

            ]
        };
        myChart.setOption(options);
        window.addEventListener('resize', () => {
            myChart.resize()
        })
    },
    // 申请人构成及趋势
    applyMakeup1sb:function(){
        let myChart = echarts.init(document.querySelector(".applyMakeup1sb"));
        let options={
            tooltip: {
                trigger: 'axis',
                axisPointer: {
                    type: 'cross',
                    label: {
                        backgroundColor: '#6a7985'
                    }
                }
            },
            legend: {
                left:30,
                icon:"rect"
            },
            toolbox: {
                feature: {
                    saveAsImage: {
                        title:false
                    }
                },
                bottom:30
            },
            grid: {
                left: '3%',
                right: '4%',
                bottom: '3%',
                containLabel: true
            },
            xAxis: [
                {
                    type: 'category',
                    boundaryGap: true,
                    data: store.state.trendTimesb
                }
            ],
            yAxis: [
                {
                    type: 'value'
                }
            ],
            series: [
                {
                    name: '工矿企业',
                    type: 'line',
                    color:"#5B8FF9",
                    areaStyle: {
                        color:"rgba(91, 143, 249,.3)"
                    },
                    label: {
                        show: true,
                        position: 'top'
                    },
                    emphasis: {
                        focus: 'series'
                    },
                    lineStyle:{
                        color:"#5B8FF9",
                    },
                    
                    data:store.state.gkcompanysb ,
                    smooth:true
                },
                {
                    name: '科研院所',
                    type: 'line',
                    color:'#5AD8A6',
                    areaStyle: {
                        color:"rgba(90, 216, 166,.3)"
                    },
                    label: {
                        show: true,
                        position: 'top'
                    },
                    emphasis: {
                        focus: 'series'
                    },
                    lineStyle:{
                        color:"#5AD8A6",
                    },
                
                    data: store.state.sciencedwsb,
                    smooth:true
                },
                {
                    name: '大专院校',
                    type: 'line',
                    color:"#5D7092",
                    areaStyle: {
                        color:'rgba(93, 112, 146,.3)'
                    },
                    emphasis: {
                        focus: 'series'
                    },
                    label: {
                        show: true,
                        position: 'top'
                    },
                    lineStyle:{
                        color:"#5D7092",
                    },
           
                    data: store.state.dzschoolsb,
                    smooth:true
                },
                {
                    name: '机关团体',
                    type: 'line',
                    color:"#F6BD16",
                    areaStyle: {
                        color:"rgba(246, 189, 22,.3)"
                    },
                    label: {
                        show: true,
                        position: 'top'
                    },
                    emphasis: {
                        focus: 'series'
                    },
                    lineStyle:{
                        color:"#F6BD16",
                    },
          
                    data: store.state.jggroupsb,
                    smooth:true
                },
                {
                    name: '个人',
                    type: 'line',
                    color:"#E8684A",
                    label: {
                        show: true,
                        position: 'top'
                    },
                    areaStyle: {
                        color:"rgba(232, 104, 74,.3)"
                    },
                    emphasis: {
                        focus: 'series'
                    },
                    lineStyle:{
                        color:"#E8684A",
                    },
              
                    data: store.state.singlesb,
                    smooth:true
                }
            ]
        }
        myChart.setOption(options);
        window.addEventListener('resize', () => {
            myChart.resize()
        })
    },
    applyMakeup2sb:function(){
        let myChart = echarts.init(document.querySelector(".applyMakeup2sb"));
        let options={
            tooltip: {
                trigger: 'axis',
                axisPointer: {
                    type: 'cross',
                    label: {
                        backgroundColor: '#6a7985'
                    }
                }
            },
            legend: {
                left:30,
                icon:"rect"
            },
            toolbox: {
                feature: {
                    saveAsImage: {
                        title:false
                    }
                },
                bottom:30
            },
            grid: {
                left: '3%',
                right: '4%',
                bottom: '3%',
                containLabel: true
            },
            xAxis: [
                {
                    type: 'category',
                    boundaryGap: true,
                    data: store.state.trendTimesb
                }
            ],
            yAxis: [
                {
                    type: 'value'
                }
            ],
            series: [
                {
                    name: '工矿企业',
                    type: 'line',
                    color:"#5B8FF9",
                    areaStyle: {
                        color:"rgba(91, 143, 249,.3)"
                    },
                    label: {
                        show: true,
                        position: 'top'
                    },
                    emphasis: {
                        focus: 'series'
                    },
                    lineStyle:{
                        color:"#5B8FF9",
                    },
                  
                    data: store.state.gkcompanyAuthsb,
                    smooth:true
                },
                {
                    name: '科研院所',
                    type: 'line',
                    color:"#5AD8A6",
                    areaStyle: {
                        color:"rgba(90, 216, 166,.3)"
                    },
                    label: {
                        show: true,
                        position: 'top'
                    },
                    emphasis: {
                        focus: 'series'
                    },
                    lineStyle:{
                        color:"#5AD8A6",
                    },
             
                    data: store.state.sciencedwAuthsb,
                    smooth:true
                },
                {
                    name: '大专院校',
                    type: 'line',
                    color:"#5D7092",
                    areaStyle: {
                        color:'rgba(93, 112, 146,.3)'
                    },
                    label: {
                        show: true,
                        position: 'top'
                    },
                    emphasis: {
                        focus: 'series'
                    },
                    lineStyle:{
                        color:"#5D7092",
                    },
              
                    data: store.state.dzschoolAuthsb,
                    smooth:true
                },
                {
                    name: '机关团体',
                    type: 'line',
                    color:"#F6BD16",
                    areaStyle: {
                        color:"rgba(246, 189, 22,.3)"
                    },
                    emphasis: {
                        focus: 'series'
                    },
                    label: {
                        show: true,
                        position: 'top'
                    },
                    lineStyle:{
                        color:"#F6BD16",
                    },
                  
                    data: store.state.jggroupAuthsb,
                    smooth:true
                },
                {
                    name: '个人',
                    type: 'line',
                    color:"#E8684A",
                    label: {
                        show: true,
                        position: 'top'
                    },
                    areaStyle: {
                        color:"rgba(232, 104, 74,.3)"
                    },
                    emphasis: {
                        focus: 'series'
                    },
                    lineStyle:{
                        color:"#E8684A",
                    },
                
                    data: store.state.singleAuthsb,
                    smooth:true
                }
            ]
        }
        myChart.setOption(options);
        window.addEventListener('resize', () => {
            myChart.resize()
        })
    },
    // 国内商标分析榜单
    domesticsbtop1: function () {
        let myChart = echarts.init(document.querySelector(".domesticsbtop1"));
        let options = {
            tooltip: {
                trigger: 'axis',
                axisPointer: {
                    type: 'shadow'
                }
            },
            toolbox: {
                feature: {
                    saveAsImage: {
                        title:false
                    }
                },
                bottom: 10
            },
            grid: {
                left: '2%',
                right: '4%',
                bottom: '3%',
                top: "8%",
                containLabel: true
            },
            xAxis: {
                type: 'value',
                boundaryGap: [0, 0.01],
                axisLine: {
                    show: true,
                    lineStyle: {
                        color: "#ddd",
                        width: 2
                    }
                },
                axisLabel: {
                    show: true
                },
                axisTick: {
                    show: false
                }

            },
            yAxis: {
                type: 'category',
                data: store.state.topApp10MapYsb,
                axisLine: {
                    lineStyle: {
                        color: "#ddd",
                        width: 2
                    }
                },
                axisLabel: {
                    color: "#000",
                    formatter:function(params){
                        var val=""
                        if(params.length>10){
                            val=params.substr(0,10)+"..."
                            return val
                        }else{
                            return params
                        }
                    }
                },
                inverse: true
            },
            series: [
                {
                    type: 'bar',
                    data: store.state.topApp10MapXsb,
                    label: {
                        show: true,
                        color: "#000",
                        position: 'right'
                    },
                    itemStyle: {
                        normal: {
                            color: new echarts.graphic.LinearGradient(0, 0, 1, 0, [{
                                offset: 0,
                                color: '#0396FF'
                            }, {
                                offset: 1,
                                color: '#75C5FE'

                            }])
                        }
                    },
                    barMaxWidth:55
                },

            ]
        };
        myChart.setOption(options);
        window.addEventListener('resize', () => {
            myChart.resize()
        })
    },
    domesticsbtop2: function () {
        let myChart = echarts.init(document.querySelector(".domesticsbtop2"));
        let options = {
            tooltip: {
                trigger: 'axis',
                axisPointer: {
                    type: 'shadow'
                }
            },
            toolbox: {
                feature: {
                    saveAsImage: {
                        title:false
                    }
                },
                bottom: 10
            },
            grid: {
                left: '2%',
                right: '4%',
                bottom: '3%',
                top: "8%",
                containLabel: true
            },
            xAxis: {
                type: 'value',
                boundaryGap: [0, 0.01],
                axisLine: {
                    show: true,
                    lineStyle: {
                        color: "#ddd",
                        width: 2
                    }
                },
                axisLabel: {
                    show: true
                },
                axisTick: {
                    show: false
                }

            },
            yAxis: {
                type: 'category',
                data: store.state.topReg10MapYsb,
                axisLine: {
                    lineStyle: {
                        color: "#ddd",
                        width: 2
                    }
                },
                axisLabel: {
                    color: "#000",
                    formatter:function(params){
                        var val=""
                        if(params.length>10){
                            val=params.substr(0,10)+"..."
                            return val
                        }else{
                            return params
                        }
                    }
                },
                inverse: true
            },
            series: [
                {
                    type: 'bar',
                    data: store.state.topReg10MapXsb,
                    label: {
                        show: true,
                        color: "#000",
                        position: 'right'
                    },
                    itemStyle: {
                        normal: {
                            color: new echarts.graphic.LinearGradient(0, 0, 1, 0, [{
                                offset: 0,
                                color: '#0396FF'
                            }, {
                                offset: 1,
                                color: '#75C5FE'

                            }])
                        }
                    },
                    barMaxWidth:55
                },

            ]
        };
        myChart.setOption(options);
        window.addEventListener('resize', () => {
            myChart.resize()
        })
    },
    domesticsbtop3: function () {
        let myChart = echarts.init(document.querySelector(".domesticsbtop3"));
        let options = {
            tooltip: {
                trigger: 'axis',
                axisPointer: {
                    type: 'shadow'
                }
            },
            toolbox: {
                feature: {
                    saveAsImage: {
                        title:false
                    }
                },
                bottom: 10
            },
            grid: {
                left: '2%',
                right: '4%',
                bottom: '3%',
                top: "8%",
                containLabel: true
            },
            xAxis: {
                type: 'value',
                boundaryGap: [0, 0.01],
                axisLine: {
                    show: true,
                    lineStyle: {
                        color: "#ddd",
                        width: 2
                    }
                },
                axisLabel: {
                    show: true
                },
                axisTick: {
                    show: false
                }

            },
            yAxis: {
                type: 'category',
                data: store.state.topValid10MapYsb,
                axisLine: {
                    lineStyle: {
                        color: "#ddd",
                        width: 2
                    }
                },
                axisLabel: {
                    color: "#000",
                    formatter:function(params){
                        var val=""
                        if(params.length>10){
                            val=params.substr(0,10)+"..."
                            return val
                        }else{
                            return params
                        }
                    }
                },
                inverse: true
            },
            series: [
                {
                    type: 'bar',
                    data: store.state.topValid10MapXsb,
                    label: {
                        show: true,
                        color: "#000",
                        position: 'right'
                    },
                    itemStyle: {
                        normal: {
                            color: new echarts.graphic.LinearGradient(0, 0, 1, 0, [{
                                offset: 0,
                                color: '#0396FF'
                            }, {
                                offset: 1,
                                color: '#75C5FE'

                            }])
                        }
                    },
                    barMaxWidth:55
                },

            ]
        };
        myChart.setOption(options);
        window.addEventListener('resize', () => {
            myChart.resize()
        })
    },
    // 马德里商标分析
    // 1.马德里商标趋势
    mdl1sb: function () {
        let myChart = echarts.init(document.querySelector(".mdl1sb"));
        let options = {
            tooltip: {
                trigger: 'axis',
                axisPointer: {
                    type: 'cross',
                    label: {
                        backgroundColor: '#6a7985'
                    }
                },
            },
            legend: {
                show: true,
                icon: 'rect',
                right: 30
            },
            toolbox: {
                feature: {
                    saveAsImage: {
                        title:false
                    }
                },
                bottom: 10
            },
            grid: {
                left: '2%',
                top: '10%',
                right: '3%',
                bottom: '5%',
                containLabel: true,
            },
            xAxis: {
                type: 'category',
                boundaryGap: true,
                data: store.state.trendTimesb,
                axisTick: {
                    show: false
                },
                axisLine: {
                    lineStyle: {
                        color: "#ddd",
                        width: 2
                    }
                },
                axisLabel: {
                    fontSize: 12,
                    color: "#000"
                },
            },
            yAxis: {
                type: 'value',
                axisTick: {
                    show: false
                },
                axisLine: {
                    show: true,
                    lineStyle: {
                        color: "#ddd",
                        width: 2
                    }
                },
                axisLabel: {
                    fontSize: 12,
                    color: "#ddd"
                },
            },
            series: [{
                name: '注册量',
                data: store.state.mdltrendYsb,
                type: 'line',
                areaStyle: {
                    color: 'rgba(250, 100, 0,.3)'
                },
                color: '#FA6400',
                smooth: true,
                label: {
                    show: true,
                    color: "#000",
                    position: 'top'
                },
               
                lineStyle: {
                    normal: {
                        color: '#FA6400',
                        width: 2
                    }

                },
            }]
        }
        myChart.setOption(options);
        window.addEventListener('resize', () => {
            myChart.resize()
        })
    },
    // 2.马德里延伸国家TOP20
    mdl2sb: function () {
        let myChart = echarts.init(document.querySelector(".mdl2sb"));
        let options = {
            tooltip: {
                trigger: 'axis',
                axisPointer: {
                    type: 'shadow'
                }
            },
            legend: {
                show: true,
                icon: 'rect',
                right: 30
            },
            grid: {
                top: '15%',
                bottom: '8%',
                left: "5%",
                right: "3%",
            },
            toolbox: {
                feature: {
                    saveAsImage: {
                        title:false
                    }
                },
                bottom: 10
            },
            xAxis: {
                type: 'category',
                data: store.state.mdltop20Xsb,
                axisLine: {
                    show: true,
                    lineStyle: {
                        color: "#ddd",
                        width: 2

                    }
                },
                axisLabel: {
                    color: "#000",
                    show: true
                },
                axisTick: {
                    show: false
                }
            },
            yAxis: {
                type: 'value',
                axisLine: {
                    show: true,
                    lineStyle: {
                        color: "#ddd",
                        width: 2

                    }
                }
            },
            series: [{
                name: '马德里注册量',
                data: store.state.mdltop20Ysb,
                type: 'bar',
                label: {
                    show: true,
                    color: "#000",
                    position: 'top'
                },
                itemStyle: {
                    normal: {
                        color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [{
                            offset: 0,
                            color: '#2DAFFD'
                        }, {
                            offset: 1,
                            color: '#1477FB'

                        }])
                    }
                },
                barMaxWidth:55
            }]
        };
        myChart.setOption(options);
        window.addEventListener('resize', () => {
            myChart.resize()
        })
    },
    // 3.马德里注册量Top10
    mdl3sb: function () {
        let myChart = echarts.init(document.querySelector(".mdl3sb"));
        let options = {
            tooltip: {
                trigger: 'axis',
                axisPointer: {
                    type: 'shadow'
                }
            },
            toolbox: {
                feature: {
                    saveAsImage: {
                        title:false
                    }
                },
                bottom: 10
            },
            grid: {
                left: '2%',
                right: '4%',
                bottom: '3%',
                top: "8%",
                containLabel: true
            },
            xAxis: {
                type: 'value',
                boundaryGap: [0, 0.01],
                axisLine: {
                    show: true,
                    lineStyle: {
                        color: "#ddd",
                        width: 2
                    }
                },
                axisLabel: {
                    show: true
                },
                axisTick: {
                    show: false
                }

            },
            yAxis: {
                type: 'category',
                data: store.state.mdlregYsb,
                axisLine: {
                    lineStyle: {
                        color: "#ddd",
                        width: 2
                    }
                },
                axisLabel: {
                    color: "#000",
                    formatter:function(params){
                        var val=""
                        if(params.length>10){
                            val=params.substr(0,10)+"..."
                            return val
                        }else{
                            return params
                        }
                    }
                }
            },
            series: [
                {
                    type: 'bar',
                    data: store.state.mdlregXsb,
                    label: {
                        show: true,
                        color: "#000",
                        position: 'right'
                    },
                    itemStyle: {
                        normal: {
                            color: new echarts.graphic.LinearGradient(0, 0, 1, 0, [{
                                offset: 0,
                                color: '#FF6417'
                            }, {
                                offset: 1,
                                color: '#FF970C'

                            }])
                        }
                    },
                    barMaxWidth:55
                },

            ]
        };
        myChart.setOption(options);
        window.addEventListener('resize', () => {
            myChart.resize()
        })
    },
    // 商标状态分析
    statusSB: function () {
        let myChart = echarts.init(document.querySelector(".statusSB"));
        let options = {
            tooltip: {
                trigger: 'item'
            },
            toolbox: {
                feature: {
                    saveAsImage: {
                        title:false
                    }
                },
                bottom: 10
            },

            legend: {
                orient: 'vertical',
                left: 'left',
                icon: 'circle',
                top: 40,
                left: 100,
                formatter: function (name) {
                    let values = []
                    let index = 0
                    store.state.lawMapSb.forEach((ele, i) => {
                        values.push(ele.value)
                        if (ele.name == name) {
                            index = i
                        }
                    })
                    return name + "：" + values[index]
                }
            },
            series: [
                {

                    type: 'pie',
                    radius: '50%',
                    data: store.state.lawMapSb,
                    emphasis: {
                        itemStyle: {
                            shadowBlur: 10,
                            shadowOffsetX: 0,
                            shadowColor: 'rgba(0, 0, 0, 0.5)'
                        }
                    },
                    color: ['#5B8FF9', '#5AD8A6', '#5D7092'],
                    radius: ['0', '75%'],
                    center: ['50%', '50%'],
                    label: {
                        formatter: "{b}:{c}"
                    },
                }
            ]
        }
        myChart.setOption(options);
        window.addEventListener('resize', () => {
            myChart.resize()
        })
    },
    // 区域商标比较
    regionsbDCompare1:function(){
        let myChart = echarts.init(document.querySelector(".regionsbDCompare1"));
        let options={
            xAxis: {
                type: 'category',
                data: store.state.areaTmCompMapX,
                axisLabel:{
                    color:"#000",
                    interval: 0
                }
            },
            tooltip: {
                trigger: 'axis',
                axisPointer: {
                    type: 'shadow'
                },
                
            },
            toolbox: {
                feature: {
                    saveAsImage: {
                        title:false
                    }
                },
                bottom: 10
            },
            grid: {
                left: '2%',
                top: '10%',
                right: '3%',
                bottom: '5%',
                containLabel: true,
            },
            yAxis: {
                type: 'value'
            },
            series: [{
                data: store.state.areaTmCompMapY,
                type: 'bar',
                color:"#5B8FF9",
                label: {
                    show: true,
                    color: "#000",
                    position: 'top'
                },
                barMaxWidth:55
            }]
        }
        myChart.setOption(options);
        window.addEventListener('resize', () => {
            myChart.resize()
        })
    }, 
    regionsbDCompare2:function(){
        let myChart = echarts.init(document.querySelector(".regionsbDCompare2"));
        let options={
            xAxis: {
                type: 'category',
                data: store.state.areaRegTmCompMapX,
                axisLabel:{
                    color:"#000",
                    interval: 0
                }
            },
            tooltip: {
                trigger: 'axis',
                axisPointer: {
                    type: 'shadow'
                }
            },
            toolbox: {
                feature: {
                    saveAsImage: {
                        title:false
                    }
                },
                bottom: 10
            },
            grid: {
                left: '2%',
                top: '10%',
                right: '3%',
                bottom: '5%',
                containLabel: true,
            },
            yAxis: {
                type: 'value'
            },
            series: [{
                data: store.state.areaRegTmCompMapY,
                type: 'bar',
                color:"#5B8FF9",
                label: {
                    show: true,
                    color: "#000",
                    position: 'top'
                },
                barMaxWidth:55
            }]
        }
        myChart.setOption(options);
        window.addEventListener('resize', () => {
            myChart.resize()
        })
    }, 
    regionsbDCompare3:function(){
        let myChart = echarts.init(document.querySelector(".regionsbDCompare3"));
        let options={
            xAxis: {
                type: 'category',
                data: store.state.areaMadridTmCompMapX,
                axisLabel:{
                    color:"#000",
                    interval: 0
                }
            },
            tooltip: {
                trigger: 'axis',
                axisPointer: {
                    type: 'shadow'
                }
            },
            toolbox: {
                feature: {
                    saveAsImage: {
                        title:false
                    }
                },
                bottom: 10
            },
            grid: {
                left: '2%',
                top: '10%',
                right: '3%',
                bottom: '5%',
                containLabel: true,
            },
            yAxis: {
                type: 'value'
            },
            series: [{
                data: store.state.areaMadridTmCompMapY,
                type: 'bar',
                color:"#5B8FF9",
                label: {
                    show: true,
                    color: "#000",
                    position: 'top'
                },
                barMaxWidth:55
            }]
        }
        myChart.setOption(options);
        window.addEventListener('resize', () => {
            myChart.resize()
        })
    }, 
    // 商标运营分析
    // 1.商标转让趋势
    sbmani1SB: function () {
        let myChart = echarts.init(document.querySelector(".sbmani1SB"));
        let options = {
            tooltip: {
                trigger: 'axis',
                axisPointer: {
                    type: 'cross',
                    label: {
                        backgroundColor: '#6a7985'
                    }
                },
            },
            legend: {
                show: true,
                icon: 'rect',
                right: 30
            },
            toolbox: {
                feature: {
                    saveAsImage: {
                        title:false
                    }
                },
                bottom: 30
            },
            grid: {
                left: '2%',
                top: '15%',
                right: '8%',
                bottom: '5%',
                containLabel: true,
            },
            xAxis: {
                type: 'category',
                boundaryGap: true,
                data: store.state.trendTimesb,
                axisTick: {
                    show: false
                },
                axisLine: {
                    lineStyle: {
                        color: "#ddd",
                        width: 2
                    }
                },
                axisLabel: {
                    fontSize: 12,
                    color: "#000",
                    interval:0
                },
            },
            yAxis: {
                type: 'value',
                axisTick: {
                    show: false
                },
                axisLine: {
                    show: true,
                    lineStyle: {
                        color: "#ddd",
                        width: 2
                    }
                },
                axisLabel: {
                    fontSize: 12,
                    color: "#000"
                },
            },
            series: [{
                name: '商标转让量',
                data: store.state.tmTransferMapYsb,
                type: 'line',
                areaStyle: {
                    color: 'rgba(91, 143, 249,.3)'
                },
                label: {
                    show: true,
                    color: "#000",
                    position: 'top'
                },
                smooth: true,
                lineStyle: {
                    normal: {
                        color: '#5B8FF9',
                        width: 2
                    }

                },
            }]
        }
        myChart.setOption(options);
        window.addEventListener('resize', () => {
            myChart.resize()
        })
    },
    // 2.商标转让类别Top10
    sbmani2SB: function () {
        let myChart = echarts.init(document.querySelector(".sbmani2SB"));
        let options = {
            tooltip: {
                trigger: 'axis',
                axisPointer: {
                    type: 'shadow'
                }
            },
            legend: {
                show: true,
                icon: 'rect',
                right: 30
            },
            toolbox: {
                feature: {
                    saveAsImage: {
                        title:false
                    }
                },
                bottom: 30
            },
            grid: {
                left: '2%',
                right: '4%',
                bottom: '3%',
                top: "12%",
                containLabel: true
            },
            xAxis: {
                type: 'value',
                boundaryGap: [0, 0.01],
                axisLine: {
                    show: true,
                    lineStyle: {
                        color: "#ddd",
                        width: 2
                    }
                },
                axisLabel: {
                    show: true,
                    color: "#000",
                    interval:0
                },
                axisTick: {
                    show: false
                }

            },
            yAxis: {
                type: 'category',
                data: store.state.tmIcTrfTopYsb,
                axisLine: {
                    lineStyle: {
                        color: "#ddd",
                        width: 2
                    }
                },
                axisLabel: {
                    color: "#000",
                    formatter:function(params){
                        var val=""
                        if(params.length>10){
                            val=params.substr(0,10)+"..."
                            return val
                        }else{
                            return params
                        }
                    }
                },
                inverse: true
            },
            series: [
                {
                    name: '商标转让量',
                    type: 'bar',
                    data: store.state.tmIcTrfTopXsb,
                    label: {
                        show: true,
                        color: "#000",
                        position: 'right'
                    },
                    itemStyle: {
                        normal: {
                            color: new echarts.graphic.LinearGradient(0, 0, 1, 0, [{
                                offset: 0,
                                color: '#1477FB'
                            }, {
                                offset: 1,
                                color: '#2DAFFD'
                            }])
                        }
                    },
                    barMaxWidth:55
                },

            ]
        };
        myChart.setOption(options);
        window.addEventListener('resize', () => {
            myChart.resize()
        })
    },
    // 3.商标许可趋势
    sbmani3SB: function () {
        let myChart = echarts.init(document.querySelector(".sbmani3SB"));
        let options = {
            tooltip: {
                trigger: 'axis',
                axisPointer: {
                    type: 'cross',
                    label: {
                        backgroundColor: '#6a7985'
                    }
                },
            },
            legend: {
                show: true,
                icon: 'rect',
                right: 30
            },
            toolbox: {
                feature: {
                    saveAsImage: {
                        title:false
                    }
                },
                bottom: 30
            },
            grid: {
                left: '2%',
                top: '15%',
                right: '8%',
                bottom: '5%',
                containLabel: true,
            },
            xAxis: {
                type: 'category',
                boundaryGap: true,
                data: store.state.trendTimesb,
                axisTick: {
                    show: false
                },
                axisLine: {
                    lineStyle: {
                        color: "#ddd",
                        width: 2
                    }
                },
                axisLabel: {
                    fontSize: 12,
                    color: "#000",
                    interval:0
                },
            },
            yAxis: {
                type: 'value',
                axisTick: {
                    show: false
                },
                axisLine: {
                    show: true,
                    lineStyle: {
                        color: "#ddd",
                        width: 2
                    }
                },
                axisLabel: {
                    fontSize: 12,
                    color: "#000"
                },
            },
            series: [{
                name: '商标许可量',
                data: store.state.tmLicenseMapYsb,
                type: 'line',
                areaStyle: {
                    color: 'rgba(250, 100, 0,.3)'
                },
                color: '#FA6400',
                label: {
                    show: true,
                    color: "#000",
                    position: 'top'
                },
                smooth: true,
                lineStyle: {
                    normal: {
                        color: '#FA6400',
                        width: 2
                    }

                },
            }]
        }
        myChart.setOption(options);
        window.addEventListener('resize', () => {
            myChart.resize()
        })
    },
    // 4.商标许可类别Top10
    sbmani4SB: function () {
        let myChart = echarts.init(document.querySelector(".sbmani4SB"));
        let options = {
            tooltip: {
                trigger: 'axis',
                axisPointer: {
                    type: 'shadow'
                }
            },
            legend: {
                show: true,
                icon: 'rect',
                right: 30
            },
            toolbox: {
                feature: {
                    saveAsImage: {
                        title:false
                    }
                },
                bottom: 30
            },
            grid: {
                left: '2%',
                right: '4%',
                bottom: '3%',
                top: "12%",
                containLabel: true
            },
            xAxis: {
                type: 'value',
                boundaryGap: [0, 0.01],
                axisLine: {
                    show: true,
                    lineStyle: {
                        color: "#ddd",
                        width: 2
                    }
                },
                axisLabel: {
                    show: true,
                    color: "#000",
                    interval:0
                },
                axisTick: {
                    show: false
                }

            },
            yAxis: {
                type: 'category',
                data: store.state.tmIcLicTopYsb,
                axisLine: {
                    lineStyle: {
                        color: "#ddd",
                        width: 2
                    }
                },
                axisLabel: {
                    color: "#000",
                    formatter:function(params){
                        var val=""
                        if(params.length>10){
                            val=params.substr(0,10)+"..."
                            return val
                        }else{
                            return params
                        }
                    }
                },
                inverse: true
            },
            series: [
                {
                    name: '商标许可量',
                    type: 'bar',
                    data: store.state.tmIcLicTopXsb,
                    label: {
                        show: true,
                        color: "#000",
                        position: 'right'
                    },
                    itemStyle: {
                        normal: {
                            color: new echarts.graphic.LinearGradient(0, 0, 1, 0, [{
                                offset: 0,
                                color: '#FF9638'
                            }, {
                                offset: 1,
                                color: '#FFBC7F'
                            }])
                        }
                    },
                    barMaxWidth:55
                },

            ]
        };
        myChart.setOption(options);
        window.addEventListener('resize', () => {
            myChart.resize()
        })
    },
    // 5.商标质押趋势
    sbmani5SB: function () {
        let myChart = echarts.init(document.querySelector(".sbmani5SB"));
        let options = {
            tooltip: {
                trigger: 'axis',
                axisPointer: {
                    type: 'cross',
                    label: {
                        backgroundColor: '#6a7985'
                    }
                },
            },
            legend: {
                show: true,
                icon: 'rect',
                right: 30
            },
            toolbox: {
                feature: {
                    saveAsImage: {
                        title:false
                    }
                },
                bottom: 30
            },
            grid: {
                left: '2%',
                top: '15%',
                right: '8%',
                bottom: '5%',
                containLabel: true,
            },
            xAxis: {
                type: 'category',
                boundaryGap: true,
                data: store.state.trendTimesb,
                axisTick: {
                    show: false
                },
                axisLine: {
                    lineStyle: {
                        color: "#ddd",
                        width: 2
                    }
                },
                axisLabel: {
                    fontSize: 12,
                    color: "#000",
                    interval:0
                },
            },
            yAxis: {
                type: 'value',
                axisTick: {
                    show: false
                },
                axisLine: {
                    show: true,
                    lineStyle: {
                        color: "#ddd",
                        width: 2
                    }
                },
                axisLabel: {
                    fontSize: 12,
                    color: "#000"
                },
            },
            series: [{
                name: '商标质押量',
                data: store.state.tmPledgeMapYsb,
                type: 'line',
                areaStyle: {
                    color: 'rgba(39, 183, 99,.3)'
                },
                color: '#27B763',
                label: {
                    show: true,
                    color: "#000",
                    position: 'top'
                },
                smooth: true,
                lineStyle: {
                    normal: {
                        color: '#27B763',
                        width: 2
                    }

                },
            }]
        }
        myChart.setOption(options);
        window.addEventListener('resize', () => {
            myChart.resize()
        })
    },
    // 6.商标质押类别Top10
    sbmani6SB: function () {
        let myChart = echarts.init(document.querySelector(".sbmani6SB"));
        let options = {
            tooltip: {
                trigger: 'axis',
                axisPointer: {
                    type: 'shadow'
                }
            },
            legend: {
                show: true,
                icon: 'rect',
                right: 30
            },
            toolbox: {
                feature: {
                    saveAsImage: {
                        title:false
                    }
                },
                bottom: 30
            },
            grid: {
                left: '2%',
                right: '4%',
                bottom: '3%',
                top: "12%",
                containLabel: true
            },
            xAxis: {
                type: 'value',
                boundaryGap: [0, 0.01],
                axisLine: {
                    show: true,
                    lineStyle: {
                        color: "#ddd",
                        width: 2
                    }
                },
                axisLabel: {
                    show: true,
                    color: "#000",
                    interval:0
                },
                axisTick: {
                    show: false
                }

            },
            yAxis: {
                type: 'category',
                data: store.state.tmIcPldTopYsb,
                axisLine: {
                    lineStyle: {
                        color: "#ddd",
                        width: 2
                    }
                },
                axisLabel: {
                    color: "#000",
                    formatter:function(params){
                        var val=""
                        if(params.length>10){
                            val=params.substr(0,10)+"..."
                            return val
                        }else{
                            return params
                        }
                    }
                },
                inverse: true
            },
            series: [
                {
                    name: '商标质押量',
                    type: 'bar',
                    data: store.state.tmIcPldTopXsb,
                    label: {
                        show: true,
                        color: "#000",
                        position: 'right'
                    },
                    itemStyle: {
                        normal: {
                            color: new echarts.graphic.LinearGradient(0, 0, 1, 0, [{
                                offset: 0,
                                color: '#37C973'
                            }, {
                                offset: 1,
                                color: '#68E6AB'
                            }])
                        }
                    },
                    barMaxWidth:55
                },

            ]
        };
        myChart.setOption(options);
        window.addEventListener('resize', () => {
            myChart.resize()
        })
    },
    // 7.商标运营分析榜单
    sbmani7SB: function () {
        let myChart = echarts.init(document.querySelector(".sbmani7SB"));
        let options = {
            tooltip: {
                trigger: 'axis',
                axisPointer: {
                    type: 'shadow'
                }
            },
            toolbox: {
                feature: {
                    saveAsImage: {
                        title:false
                    }
                },
                bottom: 10
            },
            grid: {
                left: '2%',
                right: '4%',
                bottom: '3%',
                top: "8%",
                containLabel: true
            },
            xAxis: {
                type: 'value',
                boundaryGap: [0, 0.01],
                axisLine: {
                    show: true,
                    lineStyle: {
                        color: "#ddd",
                        width: 2
                    }
                },
                axisLabel: {
                    show: true
                },
                axisTick: {
                    show: false
                }

            },
            yAxis: {
                type: 'category',
                data: store.state.tmTrfTop10Ysb,
                axisLine: {
                    lineStyle: {
                        color: "#ddd",
                        width: 2
                    }
                },
                axisLabel: {
                    color: "#000",
                    formatter:function(params){
                        var val=""
                        if(params.length>10){
                            val=params.substr(0,10)+"..."
                            return val
                        }else{
                            return params
                        }
                    }
                },
                inverse:true
            },
            series: [
                {
                    type: 'bar',
                    data: store.state.tmTrfTop10Xsb,
                    label: {
                        show: true,
                        color: "#000",
                        position: 'right'
                    },
                    itemStyle: {
                        normal: {
                            color: new echarts.graphic.LinearGradient(0, 0, 1, 0, [{
                                offset: 0,
                                color: '#1477FB'
                            }, {
                                offset: 1,
                                color: '#2DAFFD'

                            }])
                        }
                    },
                    barMaxWidth:55
                },

            ]
        };
        myChart.setOption(options);
        window.addEventListener('resize', () => {
            myChart.resize()
        })
    },
    sbmani7xkSB: function () {
        let myChart = echarts.init(document.querySelector(".sbmani7xkSB"));
        let options = {
            tooltip: {
                trigger: 'axis',
                axisPointer: {
                    type: 'shadow'
                }
            },
            toolbox: {
                feature: {
                    saveAsImage: {
                        title:false
                    }
                },
                bottom: 10
            },
            grid: {
                left: '2%',
                right: '4%',
                bottom: '3%',
                top: "8%",
                containLabel: true
            },
            xAxis: {
                type: 'value',
                boundaryGap: [0, 0.01],
                axisLine: {
                    show: true,
                    lineStyle: {
                        color: "#ddd",
                        width: 2
                    }
                },
                axisLabel: {
                    show: true
                },
                axisTick: {
                    show: false
                }

            },
            yAxis: {
                type: 'category',
                data: store.state.tmLicTop10Ysb,
                axisLine: {
                    lineStyle: {
                        color: "#ddd",
                        width: 2
                    }
                },
                axisLabel: {
                    color: "#000",
                    formatter:function(params){
                        var val=""
                        if(params.length>10){
                            val=params.substr(0,10)+"..."
                            return val
                        }else{
                            return params
                        }
                    }
                },
                inverse:true
            },
            series: [
                {
                    type: 'bar',
                    data: store.state.tmLicTop10Xsb,
                    label: {
                        show: true,
                        color: "#000",
                        position: 'right'
                    },
                    itemStyle: {
                        normal: {
                            color: new echarts.graphic.LinearGradient(0, 0, 1, 0, [{
                                offset: 0,
                                color: '#1477FB'
                            }, {
                                offset: 1,
                                color: '#2DAFFD'

                            }])
                        }
                    },
                    barMaxWidth:55
                },

            ]
        };
        myChart.setOption(options);
        window.addEventListener('resize', () => {
            myChart.resize()
        })
    },
    sbmani7zySB: function () {
        let myChart = echarts.init(document.querySelector(".sbmani7zySB"));
        let options = {
            tooltip: {
                trigger: 'axis',
                axisPointer: {
                    type: 'shadow'
                }
            },
            toolbox: {
                feature: {
                    saveAsImage: {
                        title:false
                    }
                },
                bottom: 10
            },
            grid: {
                left: '2%',
                right: '4%',
                bottom: '3%',
                top: "8%",
                containLabel: true
            },
            xAxis: {
                type: 'value',
                boundaryGap: [0, 0.01],
                axisLine: {
                    show: true,
                    lineStyle: {
                        color: "#ddd",
                        width: 2
                    }
                },
                axisLabel: {
                    show: true
                },
                axisTick: {
                    show: false
                }

            },
            yAxis: {
                type: 'category',
                data: store.state.tmPldTop10Ysb,
                axisLine: {
                    lineStyle: {
                        color: "#ddd",
                        width: 2
                    }
                },
                axisLabel: {
                    color: "#000",
                    formatter:function(params){
                        var val=""
                        if(params.length>10){
                            val=params.substr(0,10)+"..."
                            return val
                        }else{
                            return params
                        }
                    }
                },
                inverse:true
            },
            series: [
                {
                    type: 'bar',
                    data: store.state.tmPldTop10Xsb,
                    label: {
                        show: true,
                        color: "#000",
                        position: 'right'
                    },
                    itemStyle: {
                        normal: {
                            color: new echarts.graphic.LinearGradient(0, 0, 1, 0, [{
                                offset: 0,
                                color: '#1477FB'
                            }, {
                                offset: 1,
                                color: '#2DAFFD'

                            }])
                        }
                    },
                    barMaxWidth:55
                },

            ]
        };
        myChart.setOption(options);
        window.addEventListener('resize', () => {
            myChart.resize()
        })
    },
    // 代理机构数量分布
    sbdlnum: function () {
        let myChart = echarts.init(document.querySelector(".sbdlnum"));
        let options = {
            tooltip: {
                trigger: 'item'
            },
            toolbox: {
                feature: {
                    saveAsImage: {
                        title:false
                    }
                },
                bottom: 10
            },
            legend: {
                orient: 'vertical',
                left: 'left',
                icon: 'circle',
                top: 30,
                formatter: function (name) {
                    let values = []
                    let index = 0
                    store.state.agentDist.forEach((ele, i) => {
                        values.push(ele.value)
                        if (ele.name == name) {
                            index = i
                        }
                    })
                    return name + "：" + values[index]
                }
            },
            series: [
                {
                    type: 'pie',
                    radius: '50%',
                    data: store.state.agentDist,
                    emphasis: {
                        itemStyle: {
                            shadowBlur: 10,
                            shadowOffsetX: 0,
                            shadowColor: 'rgba(0, 0, 0, 0.5)'
                        }
                    },
                    label: {
                        formatter: "{b}:{c}"
                    },
                    color: ['#F6BD16', '#5D7092', '#5AD8A6','#5B8FF9'],
                    radius: ['0', '70%'],
                    center: ['55%', '55%']
                }
            ]
        }
        myChart.setOption(options);
        window.addEventListener('resize', () => {
            myChart.resize()
        })
    },
    // 商标代理量Top10
    sbslnumtop: function () {
        let myChart = echarts.init(document.querySelector(".sbslnumtop"));
        let options = {
            tooltip: {
                trigger: 'axis',
                axisPointer: {
                    type: 'shadow'
                }
            },
            toolbox: {
                feature: {
                    saveAsImage: {
                        title:false
                    }
                },
                bottom: 30
            },
            grid: {
                left: '2%',
                right: '4%',
                bottom: '3%',
                top: "5%",
                containLabel: true
            },
            xAxis: {
                type: 'value',
                boundaryGap: [0, 0.01],
                axisLine: {
                    show: true,
                    lineStyle: {
                        color: "#ddd",
                        width: 2
                    }
                },
                axisLabel: {
                    show: true,
                    color: "#000",
                    interval:0
                },
                axisTick: {
                    show: false
                }

            },
            yAxis: {
                type: 'category',
                data: store.state.agentTmTop10Y,
                axisLine: {
                    lineStyle: {
                        color: "#ddd",
                        width: 2
                    }
                },
                axisLabel: {
                    color: "#000",
                    formatter:function(params){
                        var val=""
                        if(params.length>10){
                            val=params.substr(0,10)+"..."
                            return val
                        }else{
                            return params
                        }
                    }
                },
                inverse: true
            },
            series: [
                {
                    type: 'bar',
                    data: store.state.agentTmTop10X,
                    label: {
                        show: true,
                        color: "#000",
                        position: 'right'
                    },
                    itemStyle: {
                        normal: {
                            color: new echarts.graphic.LinearGradient(0, 0, 1, 0, [{
                                offset: 0,
                                color: '#0396FF'
                            }, {
                                offset: 1,
                                color: '#75C5FE'
                            }])
                        }
                    },
                    barMaxWidth:55
                },

            ]
        };
        myChart.setOption(options);
        window.addEventListener('resize', () => {
            myChart.resize()
        })
    },
    // 非正常商标申请人分布
    noNormalsb: function () {
        let myChart = echarts.init(document.querySelector(".noNormalsb"));
        let options = {
            tooltip: {
                trigger: 'item'
            },
            toolbox: {
                feature: {
                    saveAsImage: {
                        title:false
                    }
                },
                bottom: 10
            },
            legend: {
                orient: 'vertical',
                left: 'left',
                icon: 'circle',
                top: 30,
                formatter: function (name) {
                    let values = []
                    let index = 0
                    store.state.malice.forEach((ele, i) => {
                        values.push(ele.value)
                        if (ele.name == name) {
                            index = i
                        }
                    })
                    return name + "：" + values[index]
                }
            },
            series: [
                {
                    type: 'pie',
                    radius: '50%',
                    data: store.state.malice,
                    emphasis: {
                        itemStyle: {
                            shadowBlur: 10,
                            shadowOffsetX: 0,
                            shadowColor: 'rgba(0, 0, 0, 0.5)'
                        }
                    },
                    label: {
                        formatter: "{b}:{c}"
                    },
                    color: ['#FF9D4D', '#9270CA', '#5AD8A6','#5B8FF9'],
                    radius: ['0', '70%'],
                    center: ['55%', '55%']
                }
            ]
        }
        myChart.setOption(options);
        window.addEventListener('resize', () => {
            myChart.resize()
        })
    },
    // 非正常申请商标申请量Top10
    malicetop: function () {
        let myChart = echarts.init(document.querySelector(".malicetop"));
        let options = {
            tooltip: {
                trigger: 'axis',
                axisPointer: {
                    type: 'shadow'
                }
            },
            toolbox: {
                feature: {
                    saveAsImage: {
                        title:false
                    }
                },
                bottom: 30
            },
            grid: {
                left: '2%',
                right: '4%',
                bottom: '3%',
                top: "5%",
                containLabel: true
            },
            xAxis: {
                type: 'value',
                boundaryGap: [0, 0.01],
                axisLine: {
                    show: true,
                    lineStyle: {
                        color: "#ddd",
                        width: 2
                    }
                },
                axisLabel: {
                    show: true,
                    color: "#000",
                    interval:0
                },
                axisTick: {
                    show: false
                }

            },
            yAxis: {
                type: 'category',
                data: store.state.maliceAppTmTop10Y,
                axisLine: {
                    lineStyle: {
                        color: "#ddd",
                        width: 2
                    }
                },
                axisLabel: {
                    color: "#000",
                    formatter:function(params){
                        var val=""
                        if(params.length>10){
                            val=params.substr(0,10)+"..."
                            return val
                        }else{
                            return params
                        }
                    }
                },
                inverse: true
            },
            series: [
                {
                    type: 'bar',
                    data: store.state.maliceAppTmTop10X,
                    label: {
                        show: true,
                        color: "#000",
                        position: 'right'
                    },
                    itemStyle: {
                        normal: {
                            color: new echarts.graphic.LinearGradient(0, 0, 1, 0, [{
                                offset: 0,
                                color: '#DF4A00'
                            }, {
                                offset: 1,
                                color: '#FF7C4A'
                            }])
                        }
                    },
                    barMaxWidth:55
                },

            ]
        };
        myChart.setOption(options);
        window.addEventListener('resize', () => {
            myChart.resize()
        })
    },
}